import React, { useState } from 'react';
import { UploadIcon, FileIcon, FileImageIcon, FileTextIcon } from 'lucide-react';
import { Breadcrumb } from '../components/common/Breadcrumb';
import { DocumentGrid } from '../components/documents/DocumentGrid';
import { DocumentFilters } from '../components/documents/DocumentFilters';
import { DocumentModal } from '../components/documents/DocumentModal';
const breadcrumbItems = [{
  label: 'Gestión',
  href: '#'
}, {
  label: 'Documentos'
}];
const tabs = [{
  id: 'all',
  label: 'Todos',
  icon: FileIcon
}, {
  id: 'pdf',
  label: 'PDF',
  icon: FileTextIcon
}, {
  id: 'presentation',
  label: 'Presentaciones',
  icon: FileImageIcon
}, {
  id: 'video',
  label: 'Videos',
  icon: FileImageIcon
}];
export const Documents = () => {
  const [activeTab, setActiveTab] = useState('all');
  const [selectedDocument, setSelectedDocument] = useState(null);
  return <div className="min-h-screen bg-gray-50" data-id="element-1402">
      <main className="pt-16 pl-64" data-id="element-1403">
        <div className="max-w-7xl mx-auto p-8" data-id="element-1404">
          <div className="mb-8" data-id="element-1405">
            <Breadcrumb items={breadcrumbItems} data-id="element-1406" />
            <div className="flex justify-between items-center mt-4" data-id="element-1407">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-1408">Documentos</h1>
              <button className="inline-flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors" data-id="element-1409">
                <UploadIcon className="h-5 w-5 mr-2" data-id="element-1410" />
                Subir Documento
              </button>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow" data-id="element-1411">
            <div className="border-b" data-id="element-1412">
              <nav className="flex px-6" aria-label="Tabs" data-id="element-1413">
                {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center px-6 py-4 border-b-2 font-medium text-sm ${activeTab === tab.id ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-1414">
                    <tab.icon className="h-5 w-5 mr-2" data-id="element-1415" />
                    {tab.label}
                  </button>)}
              </nav>
            </div>
            <div className="p-6" data-id="element-1416">
              <DocumentFilters data-id="element-1417" />
              <DocumentGrid onPreview={setSelectedDocument} data-id="element-1418" />
            </div>
          </div>
          <DocumentModal document={selectedDocument} onClose={() => setSelectedDocument(null)} data-id="element-1419" />
        </div>
      </main>
    </div>;
};